
export default class{

    constructor(options) {
        this.defaults = {
        	$el: false,
        	window_size: 480
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'widget-share';

		this.$el = this.options.$el;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	let url = document.location.href, title = $('title').text();
    	
    	if ( this.$el.attr('data-url-share') !== 'self' ){
    		url 	= this.$el.attr('data-url-share');
    		title 	= this.$el.attr('data-title-share');    		
    	}

    	this.$el.find( 'a' ).each( (i,el)=>{
    		let $a = $(el);

    		// https://github.com/bradvin/social-share-urls

    		switch( $a.attr( 'data-share' ) ){
    			case 'email':
    				$a.attr( 'href', 'mailto:?subject=' + title + '&body=' + url );
    				break;
    			case 'facebook':
    				$a.attr( 'href', 'https://www.facebook.com/sharer.php?u=' + url );
    				break;
    			case 'twitter':
    				$a.attr( 'href', 'https://twitter.com/intent/tweet?url=' + url + '&text=' + title );
    				break;
    			case 'linkedin':
    				$a.attr( 'href', 'https://www.linkedin.com/sharing/share-offsite/?url=' + url );
    				break;
    		}
    	});

    	this.addEvents( true );
    }

    addEvents(b){
    	if ( b ){
    		this.$el.find( 'a' ).on( 'click', (e)=>{this.onClick(e)} );
    	}
    	else{
    		this.$el.find( 'a' ).off( 'click', (e)=>{this.onClick(e)} );
    	}
    }

    onClick(e){
    	let $a = $(e.currentTarget), url = $a.attr( 'href' );
    	if ( $a.attr( 'data-share' ) !== 'email' ){

    		if ( $(window).width() > this.options.window_size ){
	    		e.preventDefault();
	    		this.openWindow( url );
    		}
    	}
    }

	openWindow(url) {
	    const left = (screen.availWidth - this.options.window_size) / 2,
	    	top = (screen.availHeight - this.options.window_size) / 2,
	    	params = "menubar=no,toolbar=no,status=no,width=" + this.options.window_size + ",height=" + this.options.window_size + ",top=" + top + ",left=" + left;
	    window.open(url,"NewWindow",params);
	}

    destroy(){
    	this.addEvents( false );
    }

}